import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

function AppBar_5({ customization, searchBarPlaceholder }) {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);

  const appBarFilter = useMemo(() => HexToHueConverter(customization?.textColor), [customization?.textColor]);

  const appBarItems = useMemo(() => {
    return customization?.items_4?.map((appBarItem, index) => {
      const isLogo = appBarItem?.id === 'logo';
      const logoAlignmentClass = isLogo ? 'w-full flex items-center ' : '';
      const logoClass = isLogo
        ? customization?.logoPosition === 'left'
          ? 'mr-auto'
          : customization?.logoPosition === 'right'
          ? 'ml-auto'
          : 'left-[50%] translate-x-[-50%] absolute'
        : 'max-h-[15.946px] max-w-[15.946px] 2xl:max-h-[20px] 2xl:max-w-[20px]';

      const logoStyle = isLogo ? { height: '40px', width: '100px', objectFit: 'contain' } : { filter: appBarFilter };

      return (
        <div className={logoAlignmentClass} key={appBarItem?.id || index}>
          <img style={logoStyle} className={logoClass} src={appBarItem?.url} alt={'bottom bar icon'} />
        </div>
      );
    });
  }, [customization?.items_4, customization?.logoPosition, appBarFilter]);

  return (
    <div>
      <div className="flex flex-row w-full items-center relative gap-[7.5px]" style={{ height: staticValues[40] }}>
        {appBarItems}
      </div>
      <div
        className="relative w-full  flex items-center"
        style={{
          backgroundColor: 'transparent',
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: customization?.searchBarBorderColor,
          borderRadius: customization?.searchBarBorderRadius,
          padding: customization?.padding,
        }}
      >
        <svg
          className="absolute left-3 top-1/2 -translate-y-1/2 text-white opacity-70"
          width={customization?.searchBarIconSize}
          height={customization?.searchBarIconSize}
          viewBox="0 0 0.6 0.6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.25 0.1a0.15 0.15 0 1 0 0 0.3 0.15 0.15 0 0 0 0 -0.3m-0.2 0.15a0.2 0.2 0 1 1 0.358 0.123l0.135 0.135a0.025 0.025 0 0 1 -0.035 0.035l-0.135 -0.135A0.2 0.2 0 0 1 0.05 0.25"
            fill={customization?.searchBarIconColor}
          />
        </svg>
        <div className="flex-1 outline-none text-white" style={{ minHeight: '24px' }} />
        {
          <span
            className="absolute left-10 text-opacity-80 pointer-events-none"
            style={{
              color: customization?.searchBarTextColor,
              fontSize: customization?.searchBarTextSize,
              fontStyle: customization?.searchBarTextStyle,
              fontWeight: customization?.searchBarTextWeight,
            }}
          >
            {searchBarPlaceholder}
          </span>
        }
      </div>
    </div>
  );
}

export default AppBar_5;
